import React from 'react';
import voca from 'voca';
import { Link } from 'react-router-dom';
import { createTooltipInfo, FREE, showProjectPlan } from '../../common/constants';
import TooltipInfo from '../../../common/TooltipInfo';
import { formatProjectDate } from '../../common/utils/date-utils';

const ProjectDetailOld = ({
  index,
  project,
  protocol,
  builderSurface,
  exchange_surface,
  configurationSurface,
  token,
}) => {
  const {
    projectType,
    projectState,
    name,
    uuid,
    dateCreated,
    framework,
    seoName,
    domainName,
    url,
    builderType,
  } = project;
  const description = createTooltipInfo(project);
  const isLiveReady = projectState === 'PAID';
  const isAiBuilder = builderType === 'BUILDER_AI';
  const projectStatus = isLiveReady ? 'Live-ready' : 'Preview only';
  const projectBuilder = isAiBuilder ? 'AI-Powered Builder' : 'Drag-and-Drop Builder';
  const showProjectLink = () => {
    if (!projectType || projectType === FREE) {
      return '';
    }
    let urlToOpen = '';
    if (domainName && domainName !== url) {
      urlToOpen = `https://${domainName}`;
    } else {
      urlToOpen = `${protocol}://${seoName}.${exchange_surface}`;
    }

    return (
      <a href={urlToOpen} target="_blank" title="View Live App" className="project-card-live-link">
        Visit Project <i className="fas fa-up-right-from-square" aria-hidden="true"></i>
      </a>
    );
  };

  const resolveProjectStudioRoute = () => {
    if (builderType === 'BUILDER_AI') {
      return `${protocol}://${seoName}.${configurationSurface}2.0/vibe-coding/${1}/v/${uuid}/chat?token=${token}`;
    } else {
      return `${protocol}://${seoName}.${builderSurface}editor/${1}/v/${uuid}/loader?token=${token}`;
    }
  };

  return (
    <div className="card project-card w-100">
      <div className="card-header project-card-header">
        <div className="project-card-header__content">
          <h4 className="project-card-title" title={`${voca.titleCase(name)}`}>
            {voca.titleCase(name)}
          </h4>
          <div className="project-card-badges" aria-label="Project attributes">
            <span
              className={`project-card-badge project-card-badge--${
                isLiveReady ? 'live' : 'preview'
              }`}
              title={
                isLiveReady
                  ? 'This project is publishable'
                  : 'This project is available for preview only'
              }
            >
              <i className="material-icons" aria-hidden="true">
                {isLiveReady ? 'check_circle' : 'visibility'}
              </i>
              {projectStatus}
            </span>
            <span
              className={`project-card-badge project-card-badge--builder project-card-badge--${
                isAiBuilder ? 'ai' : 'drag-drop'
              }`}
            >
              <i className="material-icons" aria-hidden="true">
                {isAiBuilder ? 'auto_awesome' : 'dashboard'}
              </i>
              {projectBuilder}
            </span>
          </div>
        </div>
        <div className="project-card-header__actions">
          <Link
            to={`/${uuid}/project-detail`}
            className="project-card-settings"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Project Details"
            aria-label="Open project details"
          >
            <i className="fa fa-cog" aria-hidden="true"></i>
          </Link>
        </div>
      </div>
      <div className="card-body project-card-body">
        <dl className="project-card-metadata">
          <div className="project-card-metadata__row">
            <dt>Created</dt>
            <dd>{formatProjectDate(new Date(dateCreated))}</dd>
          </div>
          <div className="project-card-metadata__row">
            <dt>Framework</dt>
            <dd>{framework ? `${framework.name} ${framework.version}` : 'N/A'}</dd>
          </div>
          <div className="project-card-metadata__row">
            <dt>Hosting</dt>
            <dd className="project-card-hosting">
              <span className="project-card-hosting__plan">
                <span>{showProjectPlan(project)}</span>
                <TooltipInfo
                  name={index}
                  description={description}
                  showHeader={true}
                  showArrow={true}
                />
              </span>
              {showProjectLink()}
            </dd>
          </div>
        </dl>
      </div>
      <div className="card-footer project-card-footer">
        <a
          href={resolveProjectStudioRoute()}
          target="_blank"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title="Configure Project"
          className="btn btn-sm btn-success text-white project-card-action"
        >
          <i className="fas fa-cog text-xxs" aria-hidden="true"></i> Project Studio
        </a>
        <a
          href={`${protocol}://${seoName}.preview.${exchange_surface}`}
          target="_blank"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title="View Live App"
          className="btn btn-sm view-button project-card-action"
        >
          <i className="fas fa-eye text-xxs" aria-hidden="true"></i> Preview
        </a>
      </div>
    </div>
  );
};

export default ProjectDetailOld;
